// @ts-nocheck
import type { Dispatch, SetStateAction } from 'react'
import { createContext } from 'react'

export const ReloadContext = createContext<{ setKey: Dispatch<SetStateAction<string>> }>()
